var _excluded = ["anchorElement", "autoFocus", "buttonProps", "children", "handleKeyDown", "handleItemClicked", "handleButtonClicked", "hideDropdown", "leaveMenuOpenOnItemClick", "isMenuOpen", "isThemeDark", "menuHtmlAttributes", "menuStyle", "renderButton", "showDropdown", "onClick", "usePopper", "usePopperPositionFixed"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// This ButtonMenuV2 is different from ButtonMenu in the implementation
// it does not use ReactModal to display the menu container
// It also calculates the position of the menu slightly differently
// All the styles remain the same as the original ButtonMenu

import * as React from 'react';
import { Manager } from 'react-popper';
import { compose, setDisplayName, withState, withHandlers } from 'recompose';
import { css } from "../../../styles/theme";
import { keyCodes } from "../../../constants/keyCodes";
import DropDownButton from "./DropDownButton";
import DropDownMenuV2 from "./DropDownMenuV2";
var CONFIG = {
  defaultClassName: 'ButtonMenu'
};
function ButtonMenu(_ref) {
  var anchorElement = _ref.anchorElement,
    autoFocus = _ref.autoFocus,
    buttonProps = _ref.buttonProps,
    children = _ref.children,
    handleKeyDown = _ref.handleKeyDown,
    handleItemClicked = _ref.handleItemClicked,
    handleButtonClicked = _ref.handleButtonClicked,
    hideDropdown = _ref.hideDropdown,
    leaveMenuOpenOnItemClick = _ref.leaveMenuOpenOnItemClick,
    isMenuOpen = _ref.isMenuOpen,
    isThemeDark = _ref.isThemeDark,
    menuHtmlAttributes = _ref.menuHtmlAttributes,
    menuStyle = _ref.menuStyle,
    renderButton = _ref.renderButton,
    showDropdown = _ref.showDropdown,
    onClick = _ref.onClick,
    usePopper = _ref.usePopper,
    usePopperPositionFixed = _ref.usePopperPositionFixed,
    dropdownProps = _objectWithoutProperties(_ref, _excluded);
  var menu = /*#__PURE__*/React.createElement("div", _extends({}, css(menuStyle || CONFIG.defaultClassName), menuHtmlAttributes), /*#__PURE__*/React.createElement(DropDownButton, {
    ariaHasPopup: true,
    ariaExpanded: isMenuOpen,
    autoFocus: autoFocus,
    buttonProps: buttonProps,
    onClick: handleButtonClicked,
    onKeyDown: handleKeyDown,
    renderButton: renderButton,
    usePopper: usePopper,
    usePopperPositionFixed: usePopperPositionFixed
  }), /*#__PURE__*/React.createElement(DropDownMenuV2, _extends({
    isOpen: isMenuOpen,
    anchorElement: anchorElement,
    onRequestClose: hideDropdown,
    onClick: handleItemClicked,
    usePopper: usePopper,
    usePopperPositionFixed: usePopperPositionFixed
  }, dropdownProps), children));
  return usePopper ? /*#__PURE__*/React.createElement(Manager, null, menu) : menu;
}
ButtonMenu.defaultProps = {
  buttonProps: {},
  menuHtmlAttributes: {},
  onKeyDown: function onKeyDown(ev) {}
};
export default compose(setDisplayName('ButtonMenu'), withState('anchorElement', 'setAnchorElement', null), withState('isMenuOpen', 'setIsMenuOpen', false), withHandlers({
  showDropdown: function showDropdown(_ref2) {
    var setAnchorElement = _ref2.setAnchorElement,
      setIsMenuOpen = _ref2.setIsMenuOpen,
      onMenuOpen = _ref2.onMenuOpen;
    return function (event) {
      setAnchorElement(event.currentTarget);
      setIsMenuOpen(true);
      if (onMenuOpen) {
        onMenuOpen();
      }
    };
  },
  hideDropdown: function hideDropdown(_ref3) {
    var setIsMenuOpen = _ref3.setIsMenuOpen,
      onMenuClose = _ref3.onMenuClose;
    return function () {
      setIsMenuOpen(false);
      if (onMenuClose) {
        onMenuClose();
      }
    };
  }
}), withHandlers({
  handleItemClicked: function handleItemClicked(_ref4) {
    var hideDropdown = _ref4.hideDropdown,
      onClick = _ref4.onClick,
      leaveMenuOpenOnItemClick = _ref4.leaveMenuOpenOnItemClick;
    return function (event, listItemValue) {
      if (!leaveMenuOpenOnItemClick) {
        hideDropdown();
      }
      if (onClick) {
        onClick(event, listItemValue);
      }
    };
  },
  handleButtonClicked: function handleButtonClicked(_ref5) {
    var isMenuOpen = _ref5.isMenuOpen,
      showDropdown = _ref5.showDropdown,
      hideDropdown = _ref5.hideDropdown;
    return function (event) {
      if (isMenuOpen) {
        hideDropdown(event);
      } else {
        showDropdown(event);
      }
    };
  },
  handleKeyDown: function handleKeyDown(_ref6) {
    var onKeyDown = _ref6.onKeyDown,
      showDropdown = _ref6.showDropdown;
    return function (event) {
      switch (event.keyCode) {
        case keyCodes.enter:
        case keyCodes.space:
        case keyCodes.down:
          event.preventDefault();
          showDropdown(event);
          break;
        default:
          if (onKeyDown) {
            onKeyDown(event);
          }
          break;
      }
    };
  }
}))(ButtonMenu);